import React from 'react';

import { useTooltip } from './use-tooltip';

type TooltipContext = ReturnType<typeof useTooltip> | null;

const TooltipContext = React.createContext<TooltipContext>(null);

const useTooltipState = () => {
  const context = React.useContext(TooltipContext);

  if (context == null) {
    throw new Error('Tooltip components must be wrapped in <Tooltip />.');
  }

  return context;
};

export { TooltipContext, useTooltipState };
